import {removeRepresentativeContact} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

export function removeRepresentativeContactMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationKey: representativeMutationKeys.removeRepresentativeContact,
    mutationFn: (contactId: number) => removeRepresentativeContact(representativeId, contactId),
    onSuccess: async (_result, _contactId, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
